<template>
	<b-container fluid>
		<b-card
			class="m-4"
			:header="
				this.$route.params.id ? 'Editar perfil' : 'Adicionar perfil'
			"
			header-text-variant="white"
			header-tag="header"
			header-bg-variant="success"
			footer-tag="footer"
		>
			<b-card-text>
				<b-form>
					<b-row>
						<b-col>
							<b-form-group
								id="descricao-form-group"
								label="Descrição"
								label-for="descricao"
							>
								<b-form-input
									id="descricao"
									v-model="perfil.descricao"
									trim
									:state="
										$v.perfil.descricao.$error
											? false
											: null
									"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group
								id="ativo-form-group"
								label="Ativo"
								label-for="ativo"
								class="mr-3"
							>
								<b-form-checkbox
									v-model="perfil.ativo"
									id="ativo"
									switch
									size="lg"
								>
								</b-form-checkbox>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
			</b-card-text>
			<template v-slot:footer>
				<b-container id="rodape" fluid>
					<b-row>
						<b-col>
							<b-button variant="success" @click="salvar">{{
								perfil.id != null ? "Alterar" : "Salvar"
							}}</b-button>
							<b-button
								class="ml-2"
								variant="danger"
								to="/casadagestante/perfil"
								>Cancelar</b-button
							>
						</b-col>
					</b-row>
				</b-container>
			</template>
		</b-card>
	</b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import mixinToast from "@/mixins/mixinToast.js";

export default {
	mixins: [mixinToast],
	data() {
		return {
			perfil: {
				id: null,
				descricao: null,
				ativo: true,
			},
		};
	},
	validations: {
		perfil: {
			descricao: {
				required,
			},
		},
	},
	methods: {
		salvar() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$bvModal
					.msgBoxConfirm("Deseja salvar o perfil?", {
						title: "Confirmação?",
						okVariant: "success",
						okTitle: "Sim",
						cancelTitle: "Não",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true,
					})
					.then((value) => {
						if (value) {
							this.$http
								.post("/casadagestante/perfil", this.perfil)
								.then((result) => {
									this.exibeToast(
										result.data.success,
										result.data.message
									);
								});
						}
					});
			}
		},
	},
	mounted() {
		if (this.$route.params.id) {
			this.$http
				.get(`/casadagestante/perfil/${this.$route.params.id}`)
				.then((result) => {
					this.perfil = result.data;
				});
		}
	},
};
</script>

<style></style>
